import { createContext, useContext } from "react";

import { NotificationHelper } from "./NotificationHelper.ts";

export const NotificationContext = createContext<NotificationHelper>(
  {} as NotificationHelper
);

export const useNotificationContext = () => useContext(NotificationContext);
